import Vue from 'vue';
// Components
import Multiselect from 'vue-multiselect';
import button from '@/components/custom/button';
import newTag from '@/components/custom/new-tag';
import cookies from '@/components/custom/cookies';
import carousel from '@/components/custom/carousel';
import input from '@/components/custom/input';
import textarea from '@/components/custom/textarea';
import loading from '@/components/custom/loading';
import alert from '@/components/custom/alert';
import modal from '@/components/custom/modal';
import modalv2 from '@/components/custom/modalv2';
import banner from '@/components/custom/banner';
import fullBanner from '@/components/custom/full-banner';
import select from '@/components/custom/select';
import tabs from '@/components/custom/tabs';
import loadMore from '@/components/custom/load-more';
import attachmentReader from '@/components/custom/attachment-reader';
import attachment from '@/components/custom/attachement';
import newCompetition from '@/components/custom/new-competition.vue';
import barChart from '@/components/custom/bar-chart.vue';
import VueTheMask from 'vue-the-mask';
import vSelect from 'vue-select';
import Snackbar from 'vuejs-snackbar';
import { VuePicker, VuePickerOption } from '@invisiburu/vue-picker';
import DefaultSubscriptionModal from '@/components/custom/modal/default-subscription';
import photos from '@/components/custom/photos';
import badge from '@/components/custom/badge.vue';
// Assets css
import '@invisiburu/vue-picker/dist/vue-picker.min.css';
export default () => {
    // register globally
    Vue.component('multiselect', Multiselect);
    Vue.component('eg-button', button);
    Vue.component('eg-new-tag', newTag);
    Vue.component('eg-carousel', carousel);
    Vue.component('eg-input', input);
    Vue.component('eg-textarea', textarea);
    Vue.component('eg-alert', alert);
    Vue.component('eg-modal', modal);
    Vue.component('eg-modalv2', modalv2);
    Vue.component('eg-banner', banner);
    Vue.component('eg-full-banner', fullBanner);
    Vue.component('eg-tabs', tabs);
    Vue.component('eg-select', select);
    Vue.component('eg-loading', loading);
    Vue.component('eg-attachment-reader', attachmentReader);
    Vue.component('eg-attachments', attachment);
    Vue.component('eg-new-competition', newCompetition);
    Vue.component('eg-load-more', loadMore);
    Vue.component('eg-cookies', cookies);
    Vue.component('bar-chart', barChart);
    Vue.use(VueTheMask);
    // Vue.use(flatPickr)
    Vue.component('v-select', vSelect);
    Vue.component('VuePicker', VuePicker);
    Vue.component('VuePickerOption', VuePickerOption);
    Vue.component('snackbar', Snackbar);
    Vue.component('eg-default-subscription-modal', DefaultSubscriptionModal);
    Vue.component('eg-photos', photos);
    Vue.component('eg-badge', badge);
};
